import { Card } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import MultimediaEditor from "@saleor/components/MultimediaEditor";
import PageHeader from "@saleor/components/PageHeader";
import S3TextField from "@saleor/components/S3TextField";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import SingleAutocompleteSelectField from "@saleor/components/SingleAutocompleteSelectField";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { commonMessages, sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { RecommendPopup_recommendPopup } from "@saleor/recommend/types/RecommendPopup";
import { SearchVouchers_search_edges_node } from "@saleor/searches/types/SearchVouchers";
import { FetchMoreProps } from "@saleor/types";
import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface RecommendPopupPageProps {
  recommendPopup: RecommendPopup_recommendPopup;
  createDefault: () => void;
  onBack: () => void;
  disabled: boolean;
  onSubmit: (data: RecommendPopupPageFormData) => void;
  saveButtonBarState: ConfirmButtonTransitionState;
  fromVouchersList: SearchVouchers_search_edges_node[];
  fromFetchVouchers: (query: string) => void;
  fromFetchMoreVouchers: FetchMoreProps;
  recommendVouchersList: SearchVouchers_search_edges_node[];
  recommendFetchVouchers: (query: string) => void;
  recommendFetchMoreVouchers: FetchMoreProps;
  showEvent: () => void;

  onTest: () => void;
}
export interface RecommendPopupPageFormData {
  recommendUrl: string;
  isEnable: boolean;

  formVoucherText: string;
  formImagePc: string;
  formImageMb: string;
  emailSubject: string;
  emailContent: string;
  defaultMessage: string;
  facebookMessage: string;

  recommendVoucherText: string;
  recommendImagePc: string;
  recommendImageMb: string;

  recommendVoucher: string;
  fromVoucher: string;
}
const RecommendPopupPage: React.FC<RecommendPopupPageProps> = ({
  recommendPopup,
  disabled,
  saveButtonBarState,
  createDefault,
  onBack,
  onSubmit,
  showEvent,
  onTest,
  fromVouchersList,
  fromFetchVouchers,
  fromFetchMoreVouchers,
  recommendVouchersList,
  recommendFetchVouchers,
  recommendFetchMoreVouchers
}) => {
  const intl = useIntl();
  const [selectedFromVoucher, setSelectedFromVoucher] = useStateFromProps(
    recommendPopup?.fromVoucher?.code || ""
  );
  const [
    selectedRecommendVoucher,
    setSelectedRecommendVoucher
  ] = useStateFromProps(recommendPopup?.recommendVoucher?.code || "");

  const fromVouchers = maybe(() => fromVouchersList, []).map(voucher => ({
    // label: voucher.name+"(code:"+voucher.code+")",
    label: voucher.code,
    value: voucher.id
  }));
  const recommendVouchers = maybe(() => recommendVouchersList, []).map(
    voucher => ({
      // label: voucher.name+"(code:"+voucher.code+")",
      label: voucher.code,
      value: voucher.id
    })
  );
  const initialForm: RecommendPopupPageFormData = {
    recommendUrl: maybe(() => recommendPopup.recommendUrl, ""),
    isEnable: maybe(() => recommendPopup.isEnable, false),

    formImagePc: maybe(() => recommendPopup.formImagePc, ""),
    formImageMb: maybe(() => recommendPopup.formImageMb, ""),
    formVoucherText: maybe(() => recommendPopup.formVoucherText, ""),
    fromVoucher: maybe(() => recommendPopup.fromVoucher.id, ""),
    emailSubject: maybe(() => recommendPopup.emailSubject, ""),
    emailContent: maybe(() => recommendPopup.emailContent, ""),
    defaultMessage: maybe(() => recommendPopup.defaultMessage, ""),
    facebookMessage: maybe(() => recommendPopup.facebookMessage, ""),

    recommendVoucherText: maybe(() => recommendPopup.recommendVoucherText, ""),
    recommendImagePc: maybe(() => recommendPopup.recommendImagePc, ""),
    recommendImageMb: maybe(() => recommendPopup.recommendImageMb, ""),
    recommendVoucher: maybe(() => recommendPopup.recommendVoucher.id, "")
  };
  const handleSubmit = (data: RecommendPopupPageFormData) => {
    onSubmit({
      ...data
    });
  };
  const [dirty, setDirty] = useState(false);
  return (
    <>
      <Form initial={initialForm} onSubmit={handleSubmit}>
        {({ change, data, hasChanged, setNameValue, submit }) => {
          const handleFromVoucherSelect = createSingleAutocompleteSelectHandler(
            change,
            setSelectedFromVoucher,
            fromVouchers
          );
          const handleRecommendVoucherSelect = createSingleAutocompleteSelectHandler(
            change,
            setSelectedRecommendVoucher,
            recommendVouchers
          );
          return (
            <Container>
              <AppHeader onBack={onBack}>
                <FormattedMessage {...sectionNames.configuration} />
              </AppHeader>
              <PageHeader
                title={intl.formatMessage(sectionNames.recommendPopup)}
              >
                <Button onClick={showEvent} color="primary" variant="contained">
                  <FormattedMessage
                    defaultMessage="Recommend Event"
                    description="button"
                  />
                </Button>
              </PageHeader>
              <Grid>
                {recommendPopup ? (
                  <>
                    <Card>
                      <CardTitle
                        title={intl.formatMessage(
                          commonMessages.generalInformations
                        )}
                      />
                      <CardContent>
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Recommend Url",
                            description: "Recommend Url"
                          })}
                          name={
                            "recommendUrl" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.recommendUrl}
                          onChange={change}
                        />
                        <FormSpacer />
                        <ControlledCheckbox
                          name={"isEnable" as keyof RecommendPopupPageFormData}
                          label={intl.formatMessage({
                            defaultMessage: "Enable",
                            description: "isEnable"
                          })}
                          checked={data.isEnable}
                          onChange={change}
                          disabled={disabled}
                        />
                      </CardContent>
                    </Card>
                    <CardSpacer />
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Inviter Details"
                        })}
                      />
                      <CardContent>
                        <SingleAutocompleteSelectField
                          displayValue={fromVouchers ? selectedFromVoucher : ""}
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Coupon Code(Sharer)"
                          })}
                          choices={disabled ? [] : fromVouchers}
                          name="fromVoucher"
                          value={data?.fromVoucher}
                          onChange={handleFromVoucherSelect}
                          fetchChoices={fromFetchVouchers}
                          emptyOption={true}
                          {...fromFetchMoreVouchers}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Coupon Code Text(Sharer)"
                          })}
                          name={
                            "formVoucherText" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.formVoucherText}
                          onChange={change}
                        />
                        <FormSpacer />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Image(PC)"
                          })}
                          name={
                            "formImagePc" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.formImagePc}
                          onChange={change}
                        /> */}
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Image(PC)"
                          })}
                          name={"formImagePc"}
                          value={data.formImagePc}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Image(MB)"
                          })}
                          name={
                            "formImageMb" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.formImageMb}
                          onChange={change}
                        /> */}
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Image(MB)"
                          })}
                          name={"formImageMb"}
                          value={data.formImageMb}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Facebook Message"
                          })}
                          name={
                            "facebookMessage" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.facebookMessage}
                          onChange={change}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Email Subject"
                          })}
                          name={
                            "emailSubject" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.emailSubject}
                          onChange={change}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Default Message"
                          })}
                          name={
                            "defaultMessage" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.defaultMessage}
                          onChange={change}
                        />
                        <FormSpacer />
                        <MultimediaEditor
                          initialValue={data.emailContent}
                          setDirty={setDirty}
                          editorName={"Email Content"}
                          dirty={dirty}
                          update={newtemplate => {
                            const data = {
                              target: {
                                name: "emailContent",
                                value: newtemplate
                              }
                            };
                            change(data);
                          }}
                        />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Email Content"
                          })}
                          name={
                            "emailContent" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          multiline
                          value={data.emailContent}
                          onChange={change}
                          style={{
                            overflowY: "auto",
                            maxHeight: "400px",
                            overflowX: "hidden"
                          }}
                        /> */}
                        <FormSpacer />
                        <Button
                          onClick={onTest}
                          disabled={false}
                          variant="text"
                          color="primary"
                          data-test="button"
                        >
                          Send Test
                        </Button>
                      </CardContent>
                    </Card>
                    <CardSpacer />
                    <Card>
                      <CardTitle
                        title={intl.formatMessage({
                          defaultMessage: "Invitee Popup"
                        })}
                      />
                      <CardContent>
                        <SingleAutocompleteSelectField
                          displayValue={
                            recommendVouchers ? selectedRecommendVoucher : ""
                          }
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Coupon Code(Friends)"
                          })}
                          choices={disabled ? [] : recommendVouchers}
                          name="recommendVoucher"
                          value={data?.recommendVoucher}
                          onChange={handleRecommendVoucherSelect}
                          fetchChoices={recommendFetchVouchers}
                          emptyOption={true}
                          {...recommendFetchMoreVouchers}
                        />
                        <FormSpacer />
                        <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Coupon Code Text(Friends)"
                          })}
                          name={
                            "recommendVoucherText" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.recommendVoucherText}
                          onChange={change}
                        />
                        <FormSpacer />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Image(PC)"
                          })}
                          name={
                            "recommendImagePc" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.recommendImagePc}
                          onChange={change}
                        /> */}
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Image(PC)"
                          })}
                          name={"recommendImagePc"}
                          value={data.recommendImagePc}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                        <FormSpacer />
                        {/* <TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Image(MB)"
                          })}
                          name={
                            "recommendImageMb" as keyof RecommendPopupPageFormData
                          }
                          fullWidth
                          value={data.recommendImageMb}
                          onChange={change}
                        /> */}
                        <S3TextField
                          disabled={disabled}
                          label={intl.formatMessage({
                            defaultMessage: "Popup Image(MB)"
                          })}
                          name={"recommendImageMb"}
                          value={data.recommendImageMb}
                          onChange={change}
                          setNameValue={setNameValue}
                        />
                      </CardContent>
                    </Card>
                  </>
                ) : (
                  <>
                    <Card>
                      <CardContent>
                        <Button
                          color="primary"
                          onClick={createDefault}
                          disabled={disabled}
                        >
                          <FormattedMessage
                            defaultMessage="Create Default"
                            description="button"
                          />
                        </Button>

                        <CardSpacer />
                        <p style={{ color: "#999", marginLeft: "20px" }}>
                          {
                            "New pop-up window has not been set, please initialize first"
                          }
                        </p>
                      </CardContent>
                    </Card>
                  </>
                )}
              </Grid>
              <SaveButtonBar
                disabled={(disabled || !hasChanged) && !recommendPopup}
                state={saveButtonBarState}
                onCancel={onBack}
                onSave={submit}
                onDelete={undefined}
              />
            </Container>
          );
        }}
      </Form>
    </>
  );
};
export default RecommendPopupPage;
